import { useRouter } from "next/router";
import Script from "next/script";
import { useEffect } from "react";

export const META_PIXEL_ID = "fb-pixel-data";

export const trackMetaPixelEvent = (type: "PageView" | "Schedule") => {
  // Not all medspas have a meta pixel... only track conversion if it's loaded on page
  if (window.fbq) window.fbq("track", type);
};

const handleRouteChange = () => {
  trackMetaPixelEvent("PageView");
};

const MetaPixel = ({ id }: { id: string }) => {
  const router = useRouter();

  useEffect(() => {
    if (router.events) {
      // the below will only fire on route changes (not initial load - that is handled in the script below)
      router.events.on("routeChangeComplete", handleRouteChange);
    }
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  return (
    <>
      <div id={META_PIXEL_ID} data-pixel-id={id} />
      <Script id="facebook-pixel">
        {`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        const pixelId = document.getElementById('${META_PIXEL_ID}')?.dataset.pixelId;
        if (pixelId) {
          fbq('init', pixelId);
          fbq('track', 'PageView');
        }
      `}
      </Script>
    </>
  );
};

export default MetaPixel;
